import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSPAuth } from "./SPAuthContext";

export default function SPShell({ children }) {
  const { actor, logout } = useSPAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/sales-portal/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#0b0d10] text-zinc-100" data-testid="sp-shell">
      <header className="border-b border-zinc-900 bg-[#0b0d10]/90 backdrop-blur sticky top-0 z-30">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-3">
              <div className="h-7 w-7 rounded-sm bg-sky-500/20 border border-sky-500/40 flex items-center justify-center">
                <div className="h-2.5 w-2.5 rounded-full bg-sky-400" />
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-[0.4em] text-zinc-500 leading-none">Sales Portal</div>
                <div className="text-xs text-zinc-300 leading-tight mt-0.5">Enterprise Leads Console</div>
              </div>
            </div>
            <nav className="flex items-center gap-1">
              <NavLink
                to="/sales-portal/leads"
                className={({ isActive }) =>
                  `text-[11px] uppercase tracking-[0.25em] px-3 py-2 rounded-sm transition-colors ${
                    isActive ? "text-sky-300 bg-sky-500/10" : "text-zinc-500 hover:text-zinc-200"
                  }`
                }
                data-testid="sp-nav-leads"
              >
                Leads
              </NavLink>
            </nav>
          </div>
          <div className="flex items-center gap-4">
            <div className="text-right hidden sm:block">
              <div className="text-xs text-zinc-300 leading-tight" data-testid="sp-actor-name">{actor?.name}</div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-600 leading-tight mt-0.5">
                {actor?.actor_type === "workmesh_admin" ? "WorkMesh Admin" : "Sales User"}
              </div>
            </div>
            <button
              onClick={handleLogout}
              className="text-[10px] uppercase tracking-[0.3em] text-zinc-400 hover:text-rose-300 border border-zinc-800 hover:border-rose-500/60 px-3 py-2 rounded-sm transition-colors"
              data-testid="sp-logout-btn"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-[1400px] mx-auto px-6 lg:px-10 py-8">{children}</main>
    </div>
  );
}
